import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

import React, { useEffect, useRef } from "react"
import Lenis from "@studio-freight/lenis"

const WrapWithLenis = ({ element }) => {
  const lenisRef = useRef(null)

  useEffect(() => {
    if (typeof window === "undefined") return

    const lenis = new Lenis({
      duration: 1.5,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 2,
    })

    lenisRef.current = lenis

    const raf = (time) => {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    const rafId = requestAnimationFrame(raf)

    // アンカークリック制御
    const handleClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]')
      if (!anchor) return

      const href = anchor.getAttribute("href")
      const offset = window.innerWidth < 896 ? -100 : -170

      if (href === "#") {
        e.preventDefault()
        lenisRef.current?.scrollTo(0)
        return
      }

      const targetElement = document.querySelector(href)

      if (targetElement && lenisRef.current) {
        e.preventDefault()

        const rect = targetElement.getBoundingClientRect()
        const absoluteTop = rect.top + lenisRef.current.scroll

        lenisRef.current.scrollTo(absoluteTop + offset)
      }
    }

    window.addEventListener("click", handleClick, { passive: false })

    return () => {
      cancelAnimationFrame(rafId)
      window.removeEventListener("click", handleClick)
      lenis.destroy()
    }
  }, [])

  // ページ遷移時リセット
  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true })

      setTimeout(() => {
        lenisRef.current?.resize()
      }, 50)
    }
  }, [element])

  return <>{element}</>
}

export const wrapPageElement = ({ element }) => {
  return <WrapWithLenis element={element} />
}